/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import App from './App';
import router from './router';
import components from './components';
import utils from './utils';
import './assets/element-theme/index.css';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/common.less';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import '../static/plugins/ztree/js/jquery-1.4.4.min';
import '../static/plugins/ztree/js/jquery.ztree.core.min';
import '../static/plugins/ztree/js/jquery.ztree.excheck.min';
import '../static/plugins/ztree/js/jquery.ztree.exedit';

import '@/components/ef/index.css';

import timeFormatter from './utils/format-time';
import numberFormatter from './utils/format-currency';

window.eventBus = new Vue();// 隐式关联
Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small' }); // 添加ElementUI
Vue.use(components); // 添加组件库
Vue.use(utils); // 添加工具集

/* eslint-disable */
function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  const name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
        (vm.$options && vm.$options._componentTag)
    : vm.name;
  return (
    (name ? `component <${name}>` : 'anonymous component') +
      (vm._isVue && vm.$options && vm.$options.__file
        ? ` at ${vm.$options && vm.$options.__file}`
        : '')
  );
}

Object.keys(timeFormatter).forEach(key => {
  Vue.prototype[key] = timeFormatter[key];
  Vue.filter(key, timeFormatter[key]);
});
Object.keys(numberFormatter).forEach(key => {
  Vue.prototype[key] = numberFormatter[key];
  Vue.filter(key, numberFormatter[key]);
});
/* eslint-enable */

Vue.config.errorHandler = (err, vm, info) => {
  // handle error
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  if (window.FMT) {
    if (vm) {
      const componentName = formatComponentName(vm);
      const propsData = vm.$options && vm.$options.propsData;
      window.FMT.errorHandler({
        err, componentName, propsData, info
      }, 'VUE');
    } else {
      window.FMT.errorHandler(err);
    }
  }
};

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     sessionStorage.removeItem('username');
//   }
//   const user = sessionStorage.getItem('username');
//   if (!user && to.path !== '/login') {
//     next({ path: '/login' });
//   } else {
//     NProgress.start();
//     next();
//   }
// });
//
// router.afterEach(() => {
//   NProgress.done();
// });
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  // // 离开详情页面，删除水印
  // if (!to.fullPath.includes('/main/case/detail/')) {
  //   if (document.getElementById('watermark')) {
  //     document.body.removeChild(document.getElementById('watermark'));
  //   }
  // }
  NProgress.done();
});

Vue.prototype.$bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js